import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {map, mergeMap, Observable, ReplaySubject} from 'rxjs';
import {AACUser} from '../models/AAC_User.model';
import {AACDataService} from './aac-data.service';
import {IcDataUserService} from './ic-data.user.service';
import {NICEAgent} from '../models/NICE_Agent.model';


@Injectable({
    providedIn: 'root'
})
export class UserService
{
    private _user: ReplaySubject<AACUser> = new ReplaySubject<AACUser>(1);

    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private _aacData: AACDataService,
        private _icUserData: IcDataUserService,
    )
    {
        this._user.next(new AACUser(new AACUser(),new NICEAgent()));
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     */
    get user$(): Observable<AACUser>
    {
        return this._user.asObservable();
    }

    set user(value: AACUser)
    {
        // Store the value
        this._user.next(value);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current logged-in user data
     */
    get(agentId: string): Observable<AACUser>
    {
        return this._icUserData.getAgent(agentId)
            .pipe(
                mergeMap(cxoneUser =>
                    this._aacData.getRegisteredUser(cxoneUser.agent.userName).pipe(map((aacUser)=> {
                            const curUser = new AACUser(aacUser, cxoneUser.agent);
                            this._user.next(curUser);
                            return curUser;
                        }
                    ))));
    }

    /**
     * Update the user
     *
     * @param user
     */
    // update(user: AACUser): Observable<any>
    // {
    //     return this._httpClient.patch<AACUser>('api/common/user', {user}).pipe(
    //         map((response) => {
    //             this._user.next(response);
    //         })
    //     );
    // }
}
